import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';

import { BaasAppState } from '@lvflanders/bar';
import { BaasToastMessageService, BarI18nPipe } from '@lvflanders/bar-ng-ui';

@Component({
    selector: 'baas-container-klantnummer-widget',
    template: `@if (klantnummer()) {
        <a
            href="javascript:void(0)"
            class="klantnummer"
            (click)="onCopyKlantnummer()"
            [attr.aria-label]="'DOMAIN_STARTSCHERM.HEADER_WIDGET.USER.CLIENT_NUMBER_TOOLTIP' | i18n"
            >{{ klantnummer() }}</a
        >
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BarI18nPipe],
    host: {
        class: 'baas-container-klantnummer-widget'
    }
})
export class BaasContainerKlantnummerWidget implements OnInit {
    readonly #state = inject(BaasAppState);
    readonly #toastMessageService = inject(BaasToastMessageService);

    readonly #klantnummer = signal<string>(undefined);

    protected readonly klantnummer = computed(() => {
        const klantnummer = this.#klantnummer();
        if (klantnummer) {
            return this.#formatteerKlantnummer(klantnummer);
        }
        return undefined;
    });

    ngOnInit() {
        this.#klantnummer.set(this.#state.basiscontext?.klantnummer);
    }

    protected async onCopyKlantnummer() {
        await navigator.clipboard.writeText(this.klantnummer());
        this.#toastMessageService.addMessage({ type: 'info', text: 'Het klantnummer werd gekopieerd naar het klembord.' });
    }

    // NOTE copied from StartschermV2FormatteerInternalService
    #formatteerKlantnummer(nummer: string): string {
        if (nummer && this.#isKlantnummerGeldig(nummer)) {
            //var result = nummer;
            let result = this.#onformatteerKlantnummer(nummer);

            //add leading zero if string length is smaller than 11
            if (result.length < 11) {
                result = '0'.repeat(11 - result.length) + result;
            }

            result = result.slice(0, 3) + '.' + result.slice(3, 6) + '.' + result.slice(6, 9) + '-' + result.slice(9, 11);

            return result;
        }

        return nummer;
    }

    #onformatteerKlantnummer(nummer: string): string {
        if (nummer) {
            let result = nummer;

            //remove non-alphanumeric chars
            result = result.replace(/[^a-zA-Z0-9]*/gm, '');

            //trim leading zero if string length is larger than 11
            if (result.length > 11) {
                result = result.replace(/^0+/, '');
            }

            //add leading zero if string length is smaller than 11
            if (result.length < 11) {
                result = '0'.repeat(11 - result.length) + result;
            }

            return result;
        }

        return nummer;
    }

    #isKlantnummerGeldig(nummer: string): boolean {
        if (nummer) {
            const ongeformatteerd = this.#onformatteerKlantnummer(nummer);

            if (ongeformatteerd.length != 11) {
                return false;
            }

            if (ongeformatteerd.match(/[^0-9]/gm)) {
                return false;
            }

            const deel1 = parseInt(ongeformatteerd.slice(0, -2));
            let deel2 = parseInt(ongeformatteerd.slice(-2));

            if (deel2 == 0) {
                return false;
            }

            if (deel2 == 97) {
                deel2 = 0;
            }

            if (deel1 % 97 != deel2) {
                return false;
            }
        }

        return true;
    }
}
